/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationCrossPlayHandlersQuestProgressDto, FxIdApplicationCrossPlayHandlersQuestProgressDtoFromJSONTyped, FxIdApplicationCrossPlayHandlersQuestProgressDtoToJSON, } from './FxIdApplicationCrossPlayHandlersQuestProgressDto';
export function FxIdApplicationCrossPlayHandlersUserQuestDtoProgressFromJSON(json) {
    return FxIdApplicationCrossPlayHandlersUserQuestDtoProgressFromJSONTyped(json, false);
}
export function FxIdApplicationCrossPlayHandlersUserQuestDtoProgressFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationCrossPlayHandlersQuestProgressDto(json)) {
        return FxIdApplicationCrossPlayHandlersQuestProgressDtoFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationCrossPlayHandlersUserQuestDtoProgressToJSON(json) {
    return FxIdApplicationCrossPlayHandlersUserQuestDtoProgressToJSONTyped(json, false);
}
export function FxIdApplicationCrossPlayHandlersUserQuestDtoProgressToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationCrossPlayHandlersQuestProgressDto(value)) {
        return FxIdApplicationCrossPlayHandlersQuestProgressDtoToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationCrossPlayHandlersUserQuestDtoProgress.js.map